import { render, staticRenderFns } from "./Visualizar_Fichero.vue?vue&type=template&id=7184426a&scoped=true"
import script from "./Visualizar_Fichero.vue?vue&type=script&lang=js"
export * from "./Visualizar_Fichero.vue?vue&type=script&lang=js"
import style0 from "./Visualizar_Fichero.vue?vue&type=style&index=0&id=7184426a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7184426a",
  null
  
)

export default component.exports